import { createGetPropGetter } from '@/store/utils';

export default {
  workflows: createGetPropGetter('workflows', []),
};
